const _errs = Symbol();
const _name = Symbol();
const _email = Symbol();
const _phoneNo = Symbol();
const _isAdmin = Symbol();
const _address = Symbol();
const _documentPath = Symbol();
const _enable = Symbol();
const _userId = Symbol();
class User {
    constructor({ name, email, isAdmin, userId, enable, phoneNo, address, documentPath }) {
        this[_errs] = {};
        Object.defineProperties(this, {

            userId: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    // value = (value === "true");
                    this[_userId] = value || null;

                },
                get: function () {
                    return this[_userId];
                }
            },
            name: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (typeof value === "string" && value.length >= 1 && value !== " " && value.length <= 45) {
                        this[_name] = value.toUpperCase();
                        delete this[_errs].name;
                    } else {
                        this[_errs].name = "Name canot be empty";
                    }
                },
                get: function () {
                    return this[_name];
                }
            },
            email: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    //var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    var re = /\S+@\S+\.\S+/;
                    var success = re.test(value);
                    if (success && value.length < 45) {
                        this[_email] = value;
                        delete this[_errs].email;
                    } else {
                        this[_errs].email = "Must be a valid email within 45 character";
                    }
                },
                get: function () {
                    return this[_email];
                }
            },
            phoneNo: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (typeof value === "string" && value.length >= 10) {
                        this[_phoneNo] = value;
                        delete this[_errs].phoneNo;
                    } else {
                        this[_errs].phoneNo = "Phone number must be 10 or more characters each must be comma separated";
                    }

                },
                get: function () {

                    //console.log(this[_phoneNo]);
                    return this[_phoneNo];
                }
            },

            isAdmin: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    // value = (value === "true");
                    this[_isAdmin] = value || 0;

                },
                get: function () {
                    return this[_isAdmin];
                }
            },
            enable: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    // value = (value === "true");
                    this[_enable] = value || 0;

                },
                get: function () {
                    return this[_enable];
                }
            },

            address: {
                enumerable: true,
                configurable: true,
                set: function (value) {
                    if (typeof value === "string" && value.length >= 2 && value.length <= 100) {
                        this[_address] = value;
                        delete this[_errs].address;
                    } else {
                        this[_errs].address = "Address must be string between 2 to 100 character";
                    }
                },
                get: function () {
                    return this[_address];
                }
            },

            documentPath: {
                enumerable: true,
                configurable: true,
                set: function (value = null) {
                    this[_documentPath] = value;
                },
                get: function () {
                    return this[_documentPath];
                }
            },
        });
        this.name = name;
        this.email = email;
        this.phoneNo = phoneNo;
        this.isAdmin = isAdmin;
        this.address = address;
        this.enable = enable;
        this.userId = userId;
        this.documentPath = documentPath || null;



    }

    static validateEmail(email) {
        //var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    static validatePassword(password) {
        return (typeof password === "string" && password.length > 4 && password.length < 16);
    }

    hasError() {
        return Object.keys(this[_errs]).length > 0;
    }

    getErrors() {
        return this[_errs];
    }

}

module.exports = User;


// WEBPACK FOOTER //
// ./src/models/user.js